import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import GamesOverview from './GamesOverview';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyGamesOverview } from './companyGamesApi';

/** Company Games → Overview. Scoping comes from the token and the toggle. */
const CGamesOverview = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyGamesOverview(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Games | Shoorah</title>
      </Helmet>
      <GamesOverview fetcher={fetcher} populationLabel={isB2BFansMode ? 'members' : 'employees'} />
    </div>
  );
};

export default CGamesOverview;
